import * as React from 'react';
import { Commodity } from '@shapeable/copper-connect-types';

export const CommoditiesContext = React.createContext<Commodity[]>([]);
export const CommoditiesProvider = CommoditiesContext.Provider;